// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-6Mw","content":"styles_content__3cH35","tableWrap":"styles_tableWrap__2GRVp"};